import React from "react";
import "./styles.css";

type TProps = {
    children: React.ReactNode;
}

const Box = ({children}: TProps) => {
    return <div className="text_container">
        {children}
    </div>
}

export default React.memo(Box);